//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { date } from 'quasar'
import TimePicker from './TimePicker.vue'

export default {
  name: 'DateTimePicker',
  components: {
    TimePicker
  },
  props: {
    value: {
      type: String,
      default: null
    },
    format: {
      type: String,
      default: null
    },
    onlyDate: {
      type: Boolean,
      default: false
    },
    optionsDate: {
      type: Function,
      default: () => true
    },
    optionsTime: {
      type: Function,
      default: () => true
    },
    minuteOptions: {
      type: Array,
      default: () => undefined
    },
    withSeconds: {
      type: Boolean,
      default: false
    },
    nowBtn: {
      type: Boolean,
      default: false
    },
    confirmBtns: {
      type: Boolean,
      default: true // TODO продумать, как сделать иначе. Например, делать последовательную фокусировку на полях времени, а при клике на последнее (минуты или секунды) закрывать попап и применять значение
    }
  },
  data: function () {
    return {
      // eventHandler: null, not reactive
    }
  },
  computed: {
    complexValue: function () {
      return {
      }
    },
    localTextValue: {
      get: function () {
        return this.value
      },
      set: function (value) {
        return this.$emit('input', value)
      }
    }
  },
  // watch: {
  //   localTextValue: {
  //     handler: function (value) {
  //     },
  //     immediate: true
  //   }
  // },
  created: function () {
    document.addEventListener('keydown', this.eventHandler, true)
  },
  beforeDestroy: function () {
    document.removeEventListener('keydown', this.eventHandler, true)
  },
  mounted: function () {
  },
  methods: {
    formatMillis: function (millis) {
      if (millis) {
        return date.formatDate(millis, this.format)
      }
      return null
    },
    parseDate (value) {
      return date.extractDate(value, this.format)
    },
    parseMillis (value) {
      return this.parseDate(value).getTime()
    },

    onDateInput: function (textValue) {
      if (this.localTextValue) {
        if (textValue) {
          const newDateValue = this.parseDate(textValue)
          const localDateValue = this.parseDate(this.localTextValue)

          localDateValue.setDate(1) // Устанавливаем 1-е, чтобы избежать ситуации, когда установленное ранее 31-е переходит в 1-е при изменении месяца

          localDateValue.setFullYear(newDateValue.getFullYear())
          localDateValue.setMonth(newDateValue.getMonth())
          localDateValue.setDate(newDateValue.getDate())

          this.localTextValue = this.formatMillis(localDateValue.getTime())
          this.$emit('date-change', this.localTextValue)
        } else {
          // не сбрасываем общее значение
        }
      } else {
        this.localTextValue = textValue
        this.$emit('date-change', this.localTextValue)
      }
    },
    onTimeInput: function () {
      this.$emit('time-change', this.localTextValue)
    },
    onConfirm: function () {
      this.$emit('confirm', this.localTextValue)
    },
    onCancel: function () {
      // this.$nextTick(() => {
      //   this.popupActive = false
      // })
      // this.localTextValue = ''
      this.$emit('cancel')
    },

    eventHandler (event) {
      console.log('DateTimePicker eventHandler', event)

      if (event.code === 'Enter') {
        if (this.localTextValue) {
          this.onConfirm()
        }
      } else if (event.code === 'Escape') {
        event._ignore = true
        event.stopPropagation()
        event.stopImmediatePropagation()

        this.onCancel()
      }
    }
  }
}

